<template>
  <div class="notice-container">
    <!-- <div class="marquee" :class="{'yellow':errorLevel == 2, 'red' : errorLevel == 3}" v-if="errorLevel == 2 || errorLevel == 3">{{text}}</div> -->
    <div>{{ $t('PCPropertyList.marquee.deviceStatusTip') }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: '',
      errorLevel: '', // 门店差错标签： 1:正常差错门店，2:较高差错门店 -- 黄色  3:异常差错门店 ---红色,
      animation: null,
      timer: null,
      duration: 0,
      textWidth: 0,
      wrapWidth: 0
    };
  },
  computed: {

  },
  created(){
    // 如果是邀请估价逻辑，就不调用获取门店信息的接口，因为这个接口会返回507，然后就进入登录页了，说是邀请估价模块不需要登录哇。。。
    // if(!(this.$route.query?.formPage == 'inviteEpIntroduce')){
    //   this.getStoreMsg()
    // } else {
    //   this.$emit('setColor', {isInvite: true});
    // }
    // this.getStoreMsg()
  },
  beforeDestroy(){

  },
  methods: {
    getStoreMsg() {
      this.$api
        .getStoreMsg()
        .then((res) => {
          if (res.code === '0000') {
            const data = res.data ? res.data : {};
            const errorLevel = data.errorLevel || '';
            let text = '';
            let color = '';
            switch (errorLevel){
              case 2:
                color = 'yellow';
                text = '注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！'
                // 注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！
                //注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！
                break;
              case 3:
                color = 'red';
                text = '注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！'
                // 注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！
                //注意！系统监测到该门店近期差错率较高，请您根据真实机况本分做单，如有恶意欺诈行为将被追责！
                break;
              default:
                text = '请按实际机况填写，否则重大差错将会追责' // 请按实际机况填写，否则重大差错将会追责
                break;
            }

            this.text = text;
            this.errorLevel = errorLevel;
            this.$emit('setColor', {color});

          } else {
            this.text = '请按实际机况填写，否则重大差错将会追责' // 请按实际机况填写，否则重大差错将会追责
          }
        })
        .catch(err => {
          this.text = '请按实际机况填写，否则重大差错将会追责' // 请按实际机况填写，否则重大差错将会追责
        });
    }
  }
};
</script>

<style lang="less" scoped>
.notice-container{
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  div {
    font-size: 20px;
    color: #333;
  }
}
.notice-container .marquee {
  animation: marquee 8s linear infinite;
  transform: translateX(0);
  display: inline-block;
  font-size: 11px;
}
.yellow{
  color: #FF5F20;
}
.red{
  color: #F5222D;
}
/*.notice-container:hover .marquee {
  animation-play-state: paused;
}*/

@keyframes marquee {
  0% {
     transform: translateX(0);
  }
  100% {
     transform: translateX(-50%);
  }
}
</style>
